export default __webpack_public_path__ + "static/media/thumbnail2.291efcf8.jpg";